// extracted by mini-css-extract-plugin
export default {"title":"style_title__QUqpE","container":"style_container__CiXqZ"};